module.exports = __webpack_public_path__ + "img/5.9749114f.png";